module.exports = __webpack_public_path__ + "img/c57a276.jpg";